var map = {
	"./AddOrder.vue": [
		6320,
		320
	],
	"./Camera.vue": [
		4570,
		570
	],
	"./DefaultOptions.vue": [
		6512,
		512
	],
	"./EditDefaultOption.vue": [
		2333,
		333
	],
	"./EditOrder.vue": [
		1436,
		436
	],
	"./Login.vue": [
		6460,
		460
	],
	"./OrderAssets.vue": [
		1918,
		918
	],
	"./OrderImages.vue": [
		2037,
		37
	],
	"./Orders.vue": [
		6807,
		807
	],
	"./Profile.vue": [
		8035,
		35
	],
	"./StartPage.vue": [
		2473,
		473
	],
	"./UserManagement.vue": [
		8247,
		247
	],
	"./Workshop.vue": [
		4236,
		236
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4235;
module.exports = webpackAsyncContext;